import { ISelectorData } from '../../components/application/NewApplication';
import { InputType } from '../../components/form/form-input-constants';

export enum FORM_FIELDS {
	SEARCH = 'search',
	INFORMATION_LEVEL = 'informationLevel',
	CATEGORY = 'category'
}

export enum FORM_FIELDS_NAMES {
	SEARCH = 'Search',
	INFORMATION_LEVEL = 'Information level',
	CATEGORY = 'Category'
}

export type IActivityLogsDetails = {
	[key in FORM_FIELDS]: string | any;
};

export type IActivityLogReturnTypes = {
	search?: string;
	infoLevel?: string[];
	category?: string[];
};

export const initialValues: IActivityLogsDetails = {
	[FORM_FIELDS.SEARCH]: '',
	[FORM_FIELDS.INFORMATION_LEVEL]: [],
	[FORM_FIELDS.CATEGORY]: []
};
export const getFormattedFormFields = (formikValues): IActivityLogReturnTypes => ({
	search: formikValues?.[FORM_FIELDS.SEARCH],
	infoLevel: formikValues?.[FORM_FIELDS.INFORMATION_LEVEL],
	category: formikValues?.[FORM_FIELDS.CATEGORY]
});

export const convertToOrderActivityLogInitial = (): IActivityLogsDetails => ({
	[FORM_FIELDS.SEARCH]: '',
	[FORM_FIELDS.INFORMATION_LEVEL]: [],
	[FORM_FIELDS.CATEGORY]: [],
});

export interface IActivityLogFields {
	key: string;
	fieldName: FORM_FIELDS;
	placeholder?: string;
	label: string;
	inputType: InputType.MultiSelect | InputType.Text;
	additionalClasses?: string;
	data?: ISelectorData[];
	picker?: any;
	allValue?: string[];
	searchable?: boolean;
}
